import { api } from './client.js';
const unwrap = (r) => r.data?.data;

export const analyticsApi = {
  executive: () => api.get('/analytics/executive-summary').then(unwrap),
  project: (id) => api.get(`/analytics/project/${id}`).then(unwrap),
  qa: (id) => api.get(`/analytics/qa/${id}`).then(unwrap),
  hr: () => api.get('/analytics/hr').then(unwrap),
  finance: () => api.get('/analytics/finance').then(unwrap),
  dashboards: () => api.get('/analytics/dashboards').then(unwrap),
  saveDashboard: (payload) => api.post('/analytics/dashboards', payload).then(unwrap),
  updateDashboard: (id, payload) => api.patch(`/analytics/dashboards/${id}`, payload).then(unwrap),
  reportSources: () => api.get('/analytics/reports/sources').then(unwrap),
  runReport: (payload) => api.post('/analytics/reports/run', payload).then(unwrap),
  runReportCsv: (payload) => api.post('/analytics/reports/run?format=csv', payload, { responseType: 'blob' }).then((r) => r.data),
};

export const eventsApi = {
  list: (params) => api.get('/events', { params }).then(unwrap),
  calendar: (from, to) => api.get('/events/calendar', { params: { from, to } }).then(unwrap),
  get: (id) => api.get(`/events/${id}`).then(unwrap),
  create: (payload) => api.post('/events', payload).then(unwrap),
  invite: (id, payload) => api.post(`/events/${id}/attendees`, payload).then(unwrap),
  respond: (attendeeId, status) => api.post(`/events/attendees/${attendeeId}/respond`, { status }).then(unwrap),
};

export const adminApi = {
  organizations: () => api.get('/admin/organizations').then(unwrap),
  updateOrg: (id, patch) => api.patch(`/admin/organizations/${id}`, patch).then(unwrap),
  users: (params) => api.get('/admin/users', { params }).then(unwrap),
  inviteUser: (payload) => api.post('/admin/users/invite', payload).then(unwrap),
  deactivateUser: (id) => api.post(`/admin/users/${id}/deactivate`).then(unwrap),
  reactivateUser: (id) => api.post(`/admin/users/${id}/reactivate`).then(unwrap),
  setUserRoles: (id, roleIds) => api.put(`/admin/users/${id}/roles`, { roleIds }).then(unwrap),
  roles: () => api.get('/admin/roles').then(unwrap),
  permissions: () => api.get('/admin/permissions').then(unwrap),
  createRole: (payload) => api.post('/admin/roles', payload).then(unwrap),
  setRolePermissions: (id, permissionIds) => api.put(`/admin/roles/${id}/permissions`, { permissionIds }).then(unwrap),
  audit: (params) => api.get('/admin/audit-logs', { params }).then(unwrap),
  auditEntry: (id) => api.get(`/admin/audit-logs/${id}`).then(unwrap),
  auditSummary: () => api.get('/admin/audit-logs/summary').then(unwrap),
  auditExportUrl: (params) => {
    const qs = new URLSearchParams(params || {}).toString();
    return `/admin/audit-logs/export${qs ? `?${qs}` : ''}`;
  },
  resourceAuditTimeline: (type, id) => api.get(`/audit-logs/resource/${encodeURIComponent(type)}/${encodeURIComponent(id)}`).then(unwrap),
  health: () => api.get('/admin/health').then(unwrap),
  integrations: (orgId) => api.get('/admin/integrations', { params: orgId ? { org_id: orgId } : {} }).then(unwrap),
  upsertIntegration: (payload) => api.put('/admin/integrations', payload).then(unwrap),
};

export const apiKeysApi = {
  list: () => api.get('/api-keys').then(unwrap),
  create: (payload) => api.post('/api-keys', payload).then(unwrap),
  revoke: (id) => api.delete(`/api-keys/${id}`).then(unwrap),
};

export const webhooksApi = {
  list: () => api.get('/webhooks').then(unwrap),
  create: (payload) => api.post('/webhooks', payload).then(unwrap),
  update: (id, payload) => api.patch(`/webhooks/${id}`, payload).then(unwrap),
  remove: (id) => api.delete(`/webhooks/${id}`).then(unwrap),
  deliveries: (id) => api.get(`/webhooks/${id}/deliveries`).then(unwrap),
  test: (id, message) => api.post(`/webhooks/${id}/test`, { message }).then(unwrap),
};
